<template>
  <div @keyup.enter="login" class="page-login">
    <div class="login-container flex-box">
      <div class="img-box"></div>
      <div class="form-box flex-box">
        <h3 class="title flex-box"><img src="../assets/img/logo.png"/>普力升工艺管理系统</h3>
        <el-form :model="form" :rules="rules" ref="form" label-position="left" label-width="0px" class="demo-ruleForm login-box">
          <el-form-item prop="adminAccount">
            <el-input type="text" v-model="form.adminAccount" auto-complete="off" placeholder="请输入您的账号" prefix-icon="iconfont icon-iconfontwodea"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="form.password" auto-complete="off" placeholder="请输入您的密码" prefix-icon="iconfont icon-mima"></el-input>
          </el-form-item>
          <!--<el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>-->
          <el-form-item style="width:100%;">
            <el-button type="primary" style="width:100%;" @click.native.prevent="login" :loading="logining">登录</el-button>
            <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class='footer'>
      <p>
        <!-- Copyright © 2014-现在 杭州推宝科技有限公司 All Rights Reserved  -->
        <a href='https://beian.miit.gov.cn' target='_blank'>浙ICP备 2022012921号-1</a></p>
    </div>
  </div>
</template>

<script>
  import * as getData from '../service/getData.js'
  //import NProgress from 'nprogress'
  export default {
    data() {
      return {
        logining: false,
        form: {
          adminAccount: '',
          password: ''
        },
        rules: {
          adminAccount: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ]
        },
        checked: true
      };
    },
    mounted(){

    },
    methods: {
      handleReset2() {
        this.$refs.ruleForm2.resetFields();
      },
      login(ev) {
        var _this = this;
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.logining = true;
            getData.login(this.form.adminAccount, this.form.password).then(res => {
              // console.log(res);
              if(res.data.code == 1){
                sessionStorage.clear()
                sessionStorage['adminName']=res.data.data.admin.adminName
                sessionStorage['adminId']=res.data.data.admin.adminId
                sessionStorage['permissions'] = JSON.stringify(res.data.data.list)
                sessionStorage['user'] = JSON.stringify(res.data.data.admin)
                this.$router.push({ path: '/homePage' });
              }else{
                this.$message({
                  message: res.data.message,
                  type: 'error'
                });
                this.logining = false;
              }
            })
          } else {
            this.logining = false;
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import '../assets/css/mixin';

  .page-login{
    padding: 103px 105px;
    height: 100%;
    background: url("../assets/img/login-bg.png") no-repeat center;
    background-size: 100% 100%;
    .login-container{
      height: 100%;
      background: #f7f8fb;
      border-radius: 14px;
      overflow: hidden;
      min-height: 360px;
      .img-box{
        flex: 1;
        height: 100%;
        background: url("../assets/img/login-img.png") no-repeat 30%;
      }
      .form-box{
        @include wh(574px,100%);
        flex-direction: column;
        justify-content: center;
        .title {
          justify-content: center;
          img{
            @include wh(68px,68px);
            margin-right: 11px;
            margin-left: -9px;
            margin-top: 2px;
          }
          margin: 0 auto 75px auto;
          text-align: center;
          color: $green;
          font-size: 36px;
          font-weight: 700;
          text-shadow:0 3px 6px rgba(17,23,21,.16);
          line-height: 50px;
        }
        .login-box {
          padding: 0 90px;
          width: 100%;
          -webkit-border-radius: 5px;
          border-radius: 5px;
          -moz-border-radius: 5px;
          background-clip: padding-box;
          .remember {
            margin: 0 0 35px 0;
          }
        }
      }

    }
    .footer {
      position: absolute;
      left: 0;
      bottom: 5px;
      width: 100%;
      // background: rgba(255, 255, 255, 1);
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      a {
        color: #999;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/view/login.vue